/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FolderResponseListServiceResult } from '../models/FolderResponseListServiceResult';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class UnitFoldersApiClient {

    /**
     * Used to return details of folders which contain a logical grouping of one or more units.
     * @returns FolderResponseListServiceResult Success
     * @throws ApiError
     */
    public static getApiV1Folder(): CancelablePromise<FolderResponseListServiceResult> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/Folder',
        });
    }

}
